// src/utils/shiprocket.js

const BASE  = 'https://apiv2.shiprocket.in/v1/external';
const EMAIL = process.env.REACT_APP_SHIPROCKET_EMAIL;
const PASS  = process.env.REACT_APP_SHIPROCKET_PASSWORD;

let cachedToken = null;
let tokenExpiry  = null;

// ── Auth ──────────────────────────────────────────────────────────────
export const getToken = async () => {
  if (cachedToken && tokenExpiry && Date.now() < tokenExpiry) return cachedToken;
  const res  = await fetch(`${BASE}/auth/login`, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ email: EMAIL, password: PASS }),
  });
  const data = await res.json();
  if (!data.token) throw new Error('Shiprocket login failed');
  cachedToken = data.token;
  tokenExpiry  = Date.now() + 9 * 24 * 60 * 60 * 1000; // cache 9 days
  return cachedToken;
};

const headers = async () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${await getToken()}`,
});

// ── Create Shipment Order ─────────────────────────────────────────────
export const createShipment = async (order) => {
  const res = await fetch(`${BASE}/orders/create/adhoc`, {
    method:  'POST',
    headers: await headers(),
    body: JSON.stringify({
      order_id:              order.orderId,
      order_date:            new Date().toISOString().split('T')[0],
      pickup_location:       'Primary',
      billing_customer_name: order.name,
      billing_address:       order.address,
      billing_city:          order.city,
      billing_pincode:       order.pincode,
      billing_state:         order.state,
      billing_country:       'India',
      billing_email:         order.email,
      billing_phone:         order.phone,
      shipping_is_billing:   true,
      order_items: order.items.map((item) => ({
        name:          item.name,
        sku:           item.id,
        units:         item.quantity,
        selling_price: item.price,
      })),
      payment_method: 'Prepaid',
      sub_total:      order.total,
      length:  15,
      breadth: 12,
      height:   5,
      weight:   0.5,
    }),
  });
  return res.json();
};

// ── Track by AWB ──────────────────────────────────────────────────────
export const trackShipment = async (awbCode) => {
  const res = await fetch(`${BASE}/courier/track/awb/${awbCode}`, {
    headers: await headers(),
  });
  return res.json();
};

// ── Get Shiprocket Order ──────────────────────────────────────────────
export const getShiprocketOrder = async (shiprocketOrderId) => {
  const res = await fetch(`${BASE}/orders/show/${shiprocketOrderId}`, {
    headers: await headers(),
  });
  return res.json();
};